import { render, staticRenderFns } from "./client-language.vue?vue&type=template&id=887f1698&"
import script from "./client-language.vue?vue&type=script&lang=js&"
export * from "./client-language.vue?vue&type=script&lang=js&"
import style0 from "./client-language.vue?vue&type=style&index=0&id=887f1698&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports